module.exports = __webpack_public_path__ + "img/dupay.310437ba.svg";